var $ = jQuery.noConflict();

jQuery(document).ready(function () {

    function getUrlParameter(qs,name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(qs);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    function amountscrolled(){
        var winheight = $(window).height()
        var docheight = $(document).height()
        var scrollTop = $(window).scrollTop()
        var trackLength = docheight - winheight
        var pctScrolled = Math.floor(scrollTop/trackLength * 100) // gets percentage scrolled (ie: 80 NaN if tracklength == 0)
        return pctScrolled;
    }

    function isValidEmailAddress(emailAddress) {
        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return pattern.test(emailAddress);
    }
	
	$(function () {
	  $('[data-toggle="tooltip"]').tooltip()
	})
	
	$.fn.followTo = function (pos) {
		var $this = this,
			$window = $(window);

		$window.scroll(function (e) {
			if ($(window).width() > 669)
				return; 
			
			if ($window.scrollTop() > pos) {
				$this.css({
					position: 'absolute',
					top: pos,
				});
			} else {
				$this.css({
					position: 'fixed',
					top: 70,
				});
			}
		});
	};

    function animateValue(obj, start, end, duration) {
        // assumes integer values for start and end
        
        var obj = obj[0];
        var range = end - start;
        // no timer shorter than 50ms (not really visible any way)
        var minTimer = 50;
        // calc step time to show all interediate values
        var stepTime = Math.abs(Math.floor(duration / range));
        
        // never go below minTimer
        stepTime = Math.max(stepTime, minTimer);
        
        // get current time and calculate desired end time
        var startTime = new Date().getTime();
        var endTime = startTime + duration;
        var timer;
      
        function run() {
            var now = new Date().getTime();
            var remaining = Math.max((endTime - now) / duration, 0);
            var value = Math.round(end - (remaining * range));
            obj.innerHTML = value;
            if (value == end) {
                clearInterval(timer);
            }
        }
        
        timer = setInterval(run, stepTime);
        run();
    }

    // ------------------- Animation --------------------
    if($('#stripes1').length) {
        gsap.from('#stripes1', {y: -240, ease: 'circ.out', duration: .5, delay: .25} );
        gsap.from('#stripes5', {y: -240, ease: 'circ.out', duration: .5, delay: .5  } );
        gsap.from('#stripes4', {y: -240, ease: 'circ.out', duration: .5, delay: .5  } );

        gsap.from('#stripes2', {y: 240, ease: 'circ.out', duration: .5, delay: .25 } );
        gsap.from('#stripes3', {y: 240, ease: 'circ.out', duration: .5, delay: .5 } );
    }
    if($('.progress').length) {
        AOS.init( {
            startEvent: 'load',
            once: false,
        });

        var typed = new Typed('#animate-type', {
            strings: ['Engage leads all day, everyday', 'Qualify leads instantly', 'Automatically send contracts', 'Track every lead in one place', 'Refer cases with a click', 'Help fill the US justice gap'],
            loop: true,
            loopCount: Infinity,
            showCursor: true,
            cursorChar: '|',
            backDelay: 3000,
            typeSpeed: 30,
            backSpeed: 5
        });

		if($(window).width < 670)
			$('.sc-announcement').followTo(60);

        var statsAnimationRan = false;
    
        function runStatsAnimation() {
            $('.progress').eq(0).css({'animation': 'dash_1 1s ease', 'animation-fill-mode': 'forwards'});
            $('.progress').eq(1).css({'animation': 'dash_2 1s ease', 'animation-fill-mode': 'forwards'});
            $('.progress').eq(2).css({'animation': 'dash_3 1s ease', 'animation-fill-mode': 'forwards'});
            $('.progress').eq(3).css({'animation': 'dash_4 1s ease', 'animation-fill-mode': 'forwards'});
            animateValue($('.value').eq(0),0,400,1000);
            animateValue($('.value').eq(1),0,40,1000);
            animateValue($('.value').eq(2),0,80,1000);
            animateValue($('.value').eq(3),0,42,1000);
        }

        $(document).on('aos:in:stat1', function(e) {
            $('.progress').eq(0).css({'animation': 'none'});
            void $('.progress').eq(0)[0].offsetWidth;
            setTimeout(function() {
                $('.progress').eq(0).css({'animation': 'dash_1 1s ease', 'animation-fill-mode': 'forwards'});
                animateValue($('.value').eq(0),0,400,1000);
            }, 100);
        });

        $(document).on('aos:in:stat2', function(e) {
            $('.progress').eq(1).css({'animation': 'none'});
            void $('.progress').eq(1)[0].offsetWidth;
            setTimeout(function() {
                $('.progress').eq(1).css({'animation': 'dash_2 1s ease', 'animation-fill-mode': 'forwards'});
                animateValue($('.value').eq(1),0,40,1000);
            }, 100);
        });

        $(document).on('aos:in:stat3', function(e) {
            $('.progress').eq(2).css({'animation': 'none'});
            void $('.progress').eq(2)[0].offsetWidth;
            setTimeout(function() {
                $('.progress').eq(2).css({'animation': 'dash_3 1s ease', 'animation-fill-mode': 'forwards'});
                animateValue($('.value').eq(2),0,80,1000);
            }, 100);
        });

        $(document).on('aos:in:stat4', function(e) {
            $('.progress').eq(3).css({'animation': 'none'});
            void $('.progress').eq(3)[0].offsetWidth;
            setTimeout(function() {
                $('.progress').eq(3).css({'animation': 'dash_4 1s ease', 'animation-fill-mode': 'forwards'});
                animateValue($('.value').eq(3),0,42,1000);
            }, 100);
        });

        if($(window).width() > 767 ) {
            $('.expand-practice-card').eq(1).attr('data-aos-delay', '450');
            $('.expand-practice-card').eq(2).attr('data-aos-delay', '900');
            $('.statistic').eq(1).attr('data-aos-delay', '300');
            $('.statistic').eq(2).attr('data-aos-delay', '500');
            $('.statistic').eq(3).attr('data-aos-delay', '800');
        }
        $(window).resize(function() {
            if($(window).width() > 767 ) {
                $('.expand-practice-card').eq(1).attr('data-aos-delay', '450');
                $('.expand-practice-card').eq(2).attr('data-aos-delay', '900');
                $('.statistic').eq(1).attr('data-aos-delay', '300');
                $('.statistic').eq(2).attr('data-aos-delay', '500');
                $('.statistic').eq(3).attr('data-aos-delay', '800');
            }
            else {
                $('.expand-practice-card').eq(1).attr('data-aos-delay', '0');
                $('.expand-practice-card').eq(2).attr('data-aos-delay', '0');
                $('.statistic').eq(1).attr('data-aos-delay', '0');
                $('.statistic').eq(2).attr('data-aos-delay', '0');
                $('.statistic').eq(3).attr('data-aos-delay', '0');
                $('.statistic').eq(2).attr('data-aos-offset', '0');
                $('.statistic').eq(3).attr('data-aos-offset', '0');
            }
			
			if ($(window).width() < 670) 
				$('.sc-announcement').followTo(60);
			else {
				$('.sc-announcement').attr('style', '');
			}
        })

        var botAnimation = bodymovin.loadAnimation( {
            container: document.getElementById('botAnimationWrapper'),
            path: '/assets/BotAnimation.json',
            renderer: 'svg',
            loop: true,
            autoplay: true
        })
        var dashAnimation = bodymovin.loadAnimation( {
            container: document.getElementById('dashAnimationWrapper'),
            path: '/assets/DashAnimation.json',
            renderer: 'svg',
            loop: true,
            autoplay: true
        })
    }
    // --------------------------------------------------
    
	$('.pricing-calculator').keyup(function(e) {
		var costPerCase = 0;
		var costStaff = 0;
		
		var monthlyCost = parseInt($('#monthly-cost').val());
		var paidLeads = parseInt($('#paid-leads').val());
		var casesGenerated = parseInt($('#cases-generated').val());
		var hourlyRate = parseInt($('#hourly-rate').val());
		var timePerContact = parseInt($('#time-per-contact').val());
		var clientCalls = parseInt($('#client-calls').val());
		
		if (paidLeads == 0) {
			$('#cost-per-chat').html('<i class="fal fa-infinity"></i>');
		}
		else if(monthlyCost / paidLeads != 0 && paidLeads.toString() != 'NaN' && monthlyCost.toString() != 'NaN') {
			$('#cost-per-chat').html('$' + (monthlyCost / paidLeads).toFixed(2));
		}
		
		if (casesGenerated == 0)
			$('#cost-per-case').html('<i class="fal fa-infinity"></i>');
		costPerCase = monthlyCost / casesGenerated;
	
		costStaff = ((timePerContact * clientCalls / 60) * hourlyRate * paidLeads) / casesGenerated;
	
		if (costStaff != Infinity && costStaff.toString() != 'NaN' && costPerCase != 0 && costPerCase.toString() != 'NaN' && costPerCase != Infinity)
			$('#cost-per-case').html('$' + (costPerCase + costStaff).toFixed(2));
		else if (costPerCase != 0 && costPerCase.toString() != 'NaN' && costPerCase != Infinity)
			$('#cost-per-case').html('$' + costPerCase.toFixed(2));
	});
	
	
    if($(".toggle-on-scroll").length)
        $(function () {
            $(document).scroll(function () {
                var $nav = $(".toggle-on-scroll");
                if($('.navbar-toggler').hasClass('collapsed'))
                    $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
            });
        });
    var $nav = $(".toggle-on-scroll");
    $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());

    $('.navbar-toggler').click(function() {
		if($(".navbar-collapse").hasClass('collapsing'))
			return;
        if($(".navbar-toggler").hasClass('collapsed')) {
            $(".fixed-top").addClass('scrolled');
        }
        else if($(document).scrollTop() < 90){
            setTimeout( function(){$('.fixed-top').removeClass('scrolled')}, 350);
        }
    })


    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('.pricing-tab-header .nav-item')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000, function () {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        };
                    });
                }
            }
        });

    $('#questionnaire-step-one').click(function() {
        $('.input-group, .form-group').removeClass('required-field');
        $('.input-group-error').html('');

        requiredElems = true;
        if(!$('input[name="email"]').val() || !isValidEmailAddress($('input[name="email"]').val())) {
            requiredElems = false;
            $('input[name="email"]').closest('.input-group').addClass('required-field');
            $('input[name="email"]').closest('.input-group').find('.input-group-error').html('Valid Email Required');
        }
        if(!$('input[name="password"]').val()) {
            requiredElems = false;
            $('input[name="password"]').closest('.input-group').addClass('required-field');
            $('input[name="password"]').closest('.input-group').find('.input-group-error').html('Password Required')
        }
        if(!$('input[name="password-confirm"]').val()) {
            requiredElems = false;
            $('input[name="password-confirm"]').closest('.input-group').addClass('required-field');
            $('input[name="password-confirm"]').closest('.input-group').find('.input-group-error').html('Please Confirm Password')
        }

        if($('input[name="password"]').val() != $('input[name="password-confirm"]').val()) {
            requiredElems = false;
            $('input[name="password"]').closest('.input-group').addClass('required-field');
            $('input[name="password-confirm"]').closest('.input-group').addClass('required-field');
            $('input[name="password-confirm"]').closest('.input-group').find('.input-group-error').html('Passwords Do Not Match')
        }

        if(!$('input[name="terms-of-use"]').is(":checked")) {
            requiredElems = false;
            $('input[name="terms-of-use"]').closest('.form-group').addClass('required-field');
            $('input[name="terms-of-use"]').closest('.form-group').find('.input-group-error').html('Must Agree to Terms of Use')
        }

        if(requiredElems) {
            $('#signup-a').hide();
            $('#signup-b').fadeIn('500');
            $(this).hide();
            $('.questionnaire-submit').fadeIn('500');
            $('#signup-headline').html('Welcome to SimplyConvert');
            $('#signup-subtitle').html('We just need a few more details to get your account setup');
        }
    })


    $('.questionnaire-submit').click(function () {
        $('.questionnaire-submit').prop('disabled', true);
        $('.questionnaire-submit').html('<i class="fal fa-spinner fa-spin"></i>')
        $('.questionnaire-error').hide();

        requiredElems = true;

        $('.required').each(function() {
            if(!$(this).val()) {
                $(this).closest('.input-group').addClass('required-field');
                $(this).closest('.input-group').find('.input-group-error').html('Required');
                requiredElems = false;
            }
            else {
                $(this).closest('.input-group').removeClass('required-field');
                $(this).closest('.input-group').find('.input-group-error').html('');
            }
        });

        if(!requiredElems) {
            $('.questionnaire-submit').html('Get Started')
            $('.questionnaire-submit').prop('disabled', false);
            return;
        }

        data = $('.sign-up-question').serialize();
        $.ajax({
            type: "POST",
            url: "/ajax/sign_up_ajax.php",
            data: {
                sign_up_questions : data
            },
            cache: false,
            success: function (data) {
                var data = $.parseJSON(data);

                if (data.code == 1) {
                    $('.questionnaire-submit').html('Get Started')
                    $('.questionnaire-submit').closest('.form-group').hide();
                    $('#signup-b').hide();
                    $('.questionnaire-success').fadeIn('500');
                }
                else if( data.code == -1) {
                    $('.questionnaire-error').html(data.msg);
                    $('.questionnaire-error').show();
                    $('.questionnaire-submit').html('Get Started')
                    $('.questionnaire-submit').prop("disabled", false);
                }
                else {
                    $('.questionnaire-submit').html('Get Started')
                    $('.questionnaire-submit').prop("disabled", false);
                    $('.questionnaire-error').html('Something went wrong, please try again.');
                    $('.questionnaire-error').show();
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = '<strong>' + xhr.status + ': ' + xhr.statusText + '</strong>  /ajax/sign_up_ajax.php';
                $('.questionnaire-error').html('Server timed out, please try again.');
                $('.questionnaire-error').show();
                $('.questionnaire-submit').html('Get Started')
                $('.questionnaire-submit').prop("disabled", false);
            }
        })
    });
	
	$('.demo-submit').click(function () {
        $('.demo-submit').prop('disabled', true);
        $('.demo-submit').html('<i class="fal fa-spinner fa-spin"></i>')
        $('.demo-error').html('');

        requiredElems = true;

        $('.required').each(function() {
            if(!$(this).val()) {
                $(this).closest('.input-group').addClass('required-field');
                $(this).closest('.input-group').find('.input-group-error').html('Required');
                requiredElems = false;
            }
            else {
                $(this).closest('.input-group').removeClass('required-field');
                $(this).closest('.input-group').find('.input-group-error').html('');
            }
        });

        if(!requiredElems) {
            $('.demo-submit').html('Request Demo')
            $('.demo-submit').prop('disabled', false);
            return;
        }

        data = $('.demo-question').serialize();
        $.ajax({
            type: "POST",
            url: "/ajax/demo_request_ajax.php",
            data: {
                demo_questions : data
            },
            cache: false,
            success: function (data) {
                var data = $.parseJSON(data);

                if (data.code == 1) {
                    $('.demo-submit').html('Request Sent!')
					$('.demo-submit').off();
                }
                else if( data.code == -1) {
                    $('.demo-error').html(data.msg);
                    $('.demo-submit').html('Get Started')
                    $('.demo-submit').prop("disabled", false);
                }
                else {
                    $('.demo-submit').html('Request Demo')
                    $('.demo-submit').prop("disabled", false);
                    $('.demo-error').html('Something went wrong, please try again.');
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = '<strong>' + xhr.status + ': ' + xhr.statusText + '</strong>  /ajax/sign_up_ajax.php';
                $('.demo-error').html('Server timed out, please try again.');
                $('.demo-submit').html('Request Demo')
                $('.demo-submit').prop("disabled", false);
            }
        })
    });

    $('.sc-toggle').click(function(e) {
        if($(this).children(".fal").last().hasClass("fa-chevron-down"))
            $(this).children(".fal").last().removeClass("fa-chevron-down").addClass("fa-chevron-up");
        else
            $(this).children(".fal").last().removeClass("fa-chevron-up").addClass("fa-chevron-down");
    });

	$('.price-desc > a.text-scorange').click(function() {
		$('#nav-contact-tab').trigger('click');
	});

	/*

	var _fname=false, _lname=false, _email=false;

	//Clear forms on on load
	(function () {
		if ($("#signup_form").length) {
			$(".form-wrapper form").find("input[type=text],input[type=email],input[type=password], textarea").val("");
		}
	}) ();

	$("#signup_form").on("submit",function(e) {
		//e.preventDefault();
		$(".btn",this).attr("disabled","true");
		$(".btn",this).html('<i class="fas fa-spinner fa-spin"></i>');
	});

	function checkSubmitButton() {
		if (_fname && _lname && _email) 
			$("#signup_btn").removeClass("disabled").removeAttr("disabled");
			
		else
			$("#signup_btn").addClass("disabled").prop('disabled',true);
	}

	$("#fname").keyup(function() {
		if ($(this).val()) {
			$(this).addClass("is-valid");
			_fname=true;
		}
		else {
			$(this).removeClass("is-valid");
			_fname=false;
		}
		checkSubmitButton();
	});

	$("#lname").keyup(function() {
		if ($(this).val()) {
			$(this).addClass("is-valid");
			_lname=true;
		}
		else {
			$(this).removeClass("is-valid");
			_lname=false;
		}
		checkSubmitButton();
	});

	function checkEmail(field) {
		 var valid = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/.test($(field).val());
            if (valid) {
                $(field).removeClass("is-invalid").addClass("is-valid");
                $(".email-error").removeClass("error");
                _email=true;
            }
            else {
                $(field).removeClass("is-valid").addClass("is-invalid");
                $(".email-error").addClass("error");
                _email=false;
            }
        checkSubmitButton();
	}

	var timer;
	$("#email").on("keydown",function() {
		$(this).removeClass("is-invalid is-valid");
        $(".email-error").removeClass("error");
		clearTimeout(timer);
	});

	$("#email").on("keyup",function() {

		var that = this;

        if ($(this).val()) {
            timer = setTimeout(function() {
				checkEmail(that);
			},1000);
        }
        else {
            _email=false;
        }
    });

	//Auto submit step 2 action page
    (function () {
        if ($("#step2-form").length) {
            $("#step2-form").submit();
        }
    }) ();

	$(".step2-resend-email").click(function(e) {

		e.preventDefault();

		var _uuid = $("#uuid").val();

        $.ajax({
            url: 'step2-resend-ajax.php',
            type: 'post',
            data: {
                uuid: _uuid
            },
            success: function(data) {
                var data = $.parseJSON(data);

                if (data.code == 1) {
					$(".alert-danger").hide();
					$(".alert-success").show('fast');
					setTimeout(function() { $(".alert-success").hide('fast'); }, 5000);
                }
                else {
					$(".alert-danger").show('fast');
					$(".alert-success").hide();
                }

				
            }
        });

    });

	function showElementFor(elem,ms) {
		

	}

	function checkLength(passwd) {
		return (passwd.length < 8) ? false : true;
	}
	function checkLower(passwd) {
      	return (!/[a-z]/.test(passwd)) ? false : true;
	}
	function checkUpper(passwd) {
      	return (!/[A-Z]/.test(passwd)) ? false : true;
	}
	function checkSpecial(passwd) {
		special = /[\s~`!@#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?()\._]/;
		return (!special.test(passwd)) ? false : true;
    }


	//$("#passwd").on("keydown",function() {
	$("#passwd").on("input",function() {
		console.log($(this).val());

		if (!$(this).val()) {
			$(".passwd-rule i").removeClass("fas fa-check-circle").addClass("fal fa-circle"); 
		}
		else {
			var length = checkLength($(this).val());
			var lower = checkLower($(this).val());
			var upper = checkUpper($(this).val());
			var special = checkSpecial($(this).val());
			if (length)
				$(".passwd-rule-length i").removeClass("fal fa-circle").addClass("fas fa-check-circle");
			else
				$(".passwd-rule-length i").removeClass("fas fa-check-circle").addClass("fal fa-circle"); 
	
			if (lower)
				$(".passwd-rule-lower i").removeClass("fal fa-circle").addClass("fas fa-check-circle");
			else
				$(".passwd-rule-lower i").removeClass("fas fa-check-circle").addClass("fal fa-circle"); 

			if (upper)
				$(".passwd-rule-upper i").removeClass("fal fa-circle").addClass("fas fa-check-circle");
			else
				$(".passwd-rule-upper i").removeClass("fas fa-check-circle").addClass("fal fa-circle"); 

			if (special)
				$(".passwd-rule-special i").removeClass("fal fa-circle").addClass("fas fa-check-circle");
			else
				$(".passwd-rule-special i").removeClass("fas fa-check-circle").addClass("fal fa-circle"); 

			if (length && lower && upper && special)  
            	$("#passwd_btn").removeClass("disabled").removeAttr("disabled");
        	else
            	$("#passwd_btn").addClass("disabled").prop('disabled',true);


		}

	});	

	$('.toggle-password').click(function() {
		inputField = $(this).closest('.input-group-append').prev();
		inputField.next().find('.show-password-icon').toggleClass("fa-eye fa-eye-slash");
		inputField.attr('type') == 'password' ? inputField.attr('type', 'text') : inputField.attr('type', 'password');
	});

	var _cname = false;
	var _curl = false;
	$("#company_name").on("input",function() {
		if ($(this).val()) {
            $(this).addClass("is-valid");
            _cname=true;
        }
        else {
            $(this).removeClass("is-valid");
            _cname=false;
        }
	 if (_cname && _curl)
            $("#acct_btn").removeClass("disabled").removeAttr("disabled");
        else
            $("#acct_btn").addClass("disabled").prop('disabled',true);
	});
	$("#company_url").on("input",function() {
		if ($(this).val()) {
            $(this).addClass("is-valid");
            _curl=true;
        }
        else {
            $(this).removeClass("is-valid");
            _curl=false;
        }
	 if (_cname && _curl)
            $("#acct_btn").removeClass("disabled").removeAttr("disabled");
        else
            $("#acct_btn").addClass("disabled").prop('disabled',true);
	});

	$(".img-button").on("click",function() {
		$(this).toggleClass("selected");

		if ($(this).hasClass("selected")) 
			$(this).find("input[type=hidden]").val("selected");
		else
			$(this).find("input[type=hidden]").val("");
			
		if ($(".img-button").hasClass("selected"))
			$("#final_btn").removeClass("disabled").removeAttr("disabled");
        else
            $("#final_btn").addClass("disabled").prop('disabled',true);

	});

	*/

})
